import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (jackpotRoll) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(jackpotRoll).apiMethod({
                method: 'GetJackpotRoll',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    ...payload,
                },
                urlArgs: {
                    jackpot_id: payload ? payload.jackpot_id : null,
                    jackpot_name: payload ? payload.jackpot_name : null,
                },
            });
            return result;
        } else {
            let result = await apiClient(jackpotRoll).apiMethod({
                method: 'GetJackpotRoll',
                headers: {},
                args: {
                    ...payload,
                },
                urlArgs: {
                    jackpot_id: payload ? payload.jackpot_id : null,
                    jackpot_name: payload ? payload.jackpot_name : null,
                },
            });
            return result;
        }
    };
};
